module.exports = __webpack_public_path__ + "static/img/3_1_6_1.399ffb1a.jpg";